<script>
  import LightboxViewer from './lightbox_viewer.svelte'
  import Icon from '../ui/icon.svelte'

  // `items` optional — pass a gallery array to enable prev/next; defaults to a single-image gallery.
  // Default thumb is square with aspect-fit (object-contain on a base-200 well) so the
  // full photo is visible — pass thumbClass to override. `actions(close)` adds controls
  // to the lightbox footer.
  let { url, title = '', thumbClass = 'h-24 w-24 object-contain bg-base-200 rounded-box', buttonClass = '', items, actions } = $props()

  let open = $state(false)
  let index = $state(0)
  let failed = $state(false)

  // Reset the failure flag when the instance is reused with a new URL.
  $effect(() => {
    url
    failed = false
  })

  const gallery = $derived(items || [{ type: 'image', url, title }])

  const show = () => {
    index = items ? items.findIndex((item) => item.url === url) : 0
    if (index < 0) index = 0
    open = true
  }
</script>

<button type="button" class="cursor-zoom-in p-0 border-0 bg-transparent {buttonClass}" onclick={show}>
  {#if url && !failed}
    <img src={url} alt={title} class={thumbClass} onerror={() => (failed = true)} />
  {:else}
    <div class="{thumbClass} bg-base-200 flex items-center justify-center">
      <Icon name="media" size="lg" class="text-base-content/40" />
    </div>
  {/if}
</button>

<LightboxViewer bind:open items={gallery} bind:index {actions} />
